import { useEffect } from "react";
import { ACCOUNTS_BASE_URL } from "../lib/api";

/** Hard navigate to Accounts — React Router <Navigate> cannot leave the SPA origin. */
export default function RedirectToAccounts() {
  useEffect(() => {
    const next = encodeURIComponent(window.location.href);
    window.location.replace(`${ACCOUNTS_BASE_URL}/?next=${next}`);
  }, []);

  return <div className="studio-loading">Taking you to sign in…</div>;
}
